/* global Swiper */

const swiperInstances = [];
document.querySelectorAll( '.b-person-slider' ).forEach( ( block ) => {

	const blockSwiper = block.querySelector( '.b-person-slider__slider' );
	if ( ! blockSwiper ) {

		return;

	}

	const sliderDirection = Boolean( parseInt( blockSwiper.dataset.direction ) );
	const itemsCount = parseInt( blockSwiper.dataset.count );
	const sliderAutoplay = Boolean( parseInt( blockSwiper.dataset.autoplay ) );
	const slidesOffsetBefore = sliderDirection ? 100 : 350;
	const loopAdditionalSlides = Number.isInteger( itemsCount ) && itemsCount > 0 ? itemsCount : 0;


	const swiperOptions = {
		speed: 8000,
		loop: true,
		centeredSlides: true,
		breakpoints: {
			320: {
				slidesPerView: 2.18
			},
			1024: {
				slidesPerView: 3.15
			},
			1200: {
				slidesPerView: 4.65
			}
		},
		slidesPerView: 4.65,
		slidesOffsetBefore: slidesOffsetBefore,
		loopAdditionalSlides,
	};

	if ( sliderAutoplay ) {

		swiperOptions.autoplay = {
			delay: 500,
			disableOnInteraction: false,
			reverseDirection: sliderDirection,
		};

	} else {

		swiperOptions.autoplay = 0;

	}

	const swiperInstance = new Swiper( blockSwiper, swiperOptions );
	swiperInstances.push( swiperInstance );

} );

window.addEventListener( 'resize', () => {

	swiperInstances.forEach( instance => instance.update() );

} );
